import React, { useState } from 'react';

import Ionicons from '@expo/vector-icons/Ionicons';
import { Box, Image } from '@rbilabs/universal-components';
import { useWindowDimensions } from 'react-native';

import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';

import {
  CustomButton,
  RetakeButton,
  RetakeText,
  SubmitYourPhotoButton,
  Title,
  TopBar,
} from './styled';
import { PhotoReviewScreenProps } from './types';
import { processPhoto } from './utils';

export const PhotoReviewScreen = ({
  photo,
  onRetake,
  onSubmit,
  onClose,
  flip,
  format,
  maxSize,
  maxWidth,
  maxHeight,
  fixMirroring = false,
}: PhotoReviewScreenProps) => {
  const { width, height } = useWindowDimensions();

  const [isLoading, setIsLoading] = useState(false);

  const submit = async () => {
    setIsLoading(true);
    const photoBase64 = await processPhoto(
      photo,
      flip,
      format,
      maxSize,
      maxWidth,
      maxHeight,
      fixMirroring
    );
    setIsLoading(false);
    onSubmit(photoBase64);
  };

  // Percentage does not work because of the absolute position that
  // is configured because of the iframe of the campaign
  // so we calculate it based in the percentage:
  // top header : 5% = 0.05
  // body : 80% = 0.8
  // bottom header : 15% = 0.15
  // Max width is 500px for web only
  const BODY_HEIGHT = height * 0.8;
  const BOTTOM_HEIGHT = height * 0.15;
  const TOP_BAR_HEIGHT = height * 0.05;
  const MAX_WIDTH = 500;
  return (
    <>
      <TopBar style={{ height: TOP_BAR_HEIGHT, width, maxWidth: MAX_WIDTH }}>
        <CustomButton onPress={onClose}>
          <Ionicons name="close" size={28} color={primitive.$white} />
        </CustomButton>
        <Box justifyContent="center" alignItems="center">
          <Title> {t('reviewPhoto')} </Title>
        </Box>
        <Box justifyContent="center" alignItems="center">
          <RetakeButton onPress={onRetake}>
            <RetakeText> {t('retakePhoto')} </RetakeText>
          </RetakeButton>
        </Box>
      </TopBar>
      <Box
        style={[
          {
            height: BODY_HEIGHT,
            width,
            maxWidth: MAX_WIDTH,
          },
        ]}
      >
        <Image
          source={{ uri: photo.uri }}
          style={[
            { height: BODY_HEIGHT, width, maxWidth: MAX_WIDTH },
            flip === 'front' ? { transform: [{ scaleX: -1 }] } : null,
          ]}
        />
      </Box>
      <Box
        alignItems="center"
        justifyContent="center"
        style={[
          {
            height: BOTTOM_HEIGHT,
            backgroundColor: primitive.$white,
            width,
            maxWidth: MAX_WIDTH,
          },
        ]}
      >
        <SubmitYourPhotoButton onPress={submit} isLoading={isLoading}>
          {t('submitYourPhoto')}
        </SubmitYourPhotoButton>
      </Box>
    </>
  );
};
